const USER_INITIAL_STATE = {
  isLoading: false,
  error: undefined,
  data: undefined,
}

export default USER_INITIAL_STATE
